import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "tab-content" }
const _hoisted_2 = { class: "settings-card" }
const _hoisted_3 = { class: "color-section" }
const _hoisted_4 = { class: "color-row" }
const _hoisted_5 = { class: "color-picker-group" }
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "hex-wrap" }
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "reset-row" }
const _hoisted_10 = { class: "save-row" }
const _hoisted_11 = {
  key: 0,
  class: "save-success"
}
const _hoisted_12 = {
  key: 0,
  class: "save-error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _cache[11] || (_cache[11] = _createStaticVNode("<div class=\"card-header\" data-v-c2465f42><div class=\"card-icon\" data-v-c2465f42><svg width=\"18\" height=\"18\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" data-v-c2465f42><circle cx=\"12\" cy=\"12\" r=\"10\" data-v-c2465f42></circle><path d=\"M12 2a10 10 0 0 1 0 20\" data-v-c2465f42></path><path d=\"M12 2c2.5 2.5 4 6 4 10s-1.5 7.5-4 10\" data-v-c2465f42></path><line x1=\"2\" y1=\"12\" x2=\"22\" y2=\"12\" data-v-c2465f42></line></svg></div><div data-v-c2465f42><h3 class=\"card-title\" data-v-c2465f42>Cores dos Relatórios</h3><p class=\"card-desc\" data-v-c2465f42>Personalize a cor de destaque usada nos PDFs de relatórios de obra e de manutenção.</p></div></div>", 1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "color-info" }, [
            _createElementVNode("span", { class: "color-label" }, "Cor de destaque dos relatórios"),
            _createElementVNode("span", { class: "color-desc" }, "Esta cor é utilizada na faixa de cabeçalho e nos títulos de seção dos PDFs exportados, tanto de obra quanto de manutenção.")
          ], -1)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("input", {
              type: "color",
              class: "color-native",
              value: _ctx.reportColor,
              onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onColorInput && _ctx.onColorInput(...args)))
            }, null, 40, _hoisted_6),
            _createElementVNode("div", _hoisted_7, [
              _cache[6] || (_cache[6] = _createElementVNode("span", { class: "hex-prefix" }, "#", -1)),
              _createElementVNode("input", {
                type: "text",
                class: "hex-input",
                value: _ctx.hexDisplay,
                maxlength: "6",
                placeholder: "0f4c81",
                onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onHexInput && _ctx.onHexInput(...args))),
                onBlur: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onHexBlur && _ctx.onHexBlur(...args)))
              }, null, 40, _hoisted_8)
            ])
          ])
        ]),
        _createElementVNode("div", {
          class: "preview-band",
          style: _normalizeStyle({ background: _ctx.reportColor })
        }, [...(_cache[8] || (_cache[8] = [
          _createElementVNode("div", { class: "preview-band-inner" }, [
            _createElementVNode("span", { class: "preview-band-title" }, "Nome da Obra · Relatório de Progresso"),
            _createElementVNode("span", { class: "preview-band-meta" }, "Seção de exemplo · Janeiro 2025")
          ], -1)
        ]))], 4),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("button", {
            type: "button",
            class: "btn-reset",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.resetToInterface && _ctx.resetToInterface(...args)))
          }, [
            _cache[9] || (_cache[9] = _createElementVNode("svg", {
              width: "13",
              height: "13",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2.2"
            }, [
              _createElementVNode("polyline", { points: "1 4 1 10 7 10" }),
              _createElementVNode("path", { d: "M3.51 15a9 9 0 1 0 .49-3.5" })
            ], -1)),
            _createTextVNode(" Usar cor da interface (" + _toDisplayString(_ctx.interfaceColorHex) + ") ", 1)
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "btn-reset btn-reset--secondary",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.resetToDefault && _ctx.resetToDefault(...args)))
          }, " Restaurar padrão (#0f4c81) ")
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("button", {
          class: "btn-save",
          type: "button",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('save')))
        }, [...(_cache[10] || (_cache[10] = [
          _createElementVNode("svg", {
            width: "15",
            height: "15",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2.2"
          }, [
            _createElementVNode("path", { d: "M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" }),
            _createElementVNode("polyline", { points: "17 21 17 13 7 13 7 21" }),
            _createElementVNode("polyline", { points: "7 3 7 8 15 8" })
          ], -1),
          _createTextVNode(" Salvar ", -1)
        ]))]),
        _createVNode(_Transition, { name: "fade" }, {
          default: _withCtx(() => [
            (_ctx.successText)
              ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.successText), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        (_ctx.errorText)
          ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(_ctx.errorText), 1))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}